import { gql } from 'graphql-query-contracts';

export const getUnit = gql(`
  query GetUnit($propertyId: UUID!, $unitId: String!) {
    unit(propertyId: $propertyId, unitId: $unitId) {
      id
      name
      description
      propertyId
      floors {
        id
        name
        index
      }
      people {
        id
        name
        email
        userId
        user {
          _id
          name
          profile {
            email
          }
          lastSeen
          _created
        }
      }
      tenants {
        id
        name
        type
        logo
        image
      }
    }
  }
`);

export const getUnitAndReferences = gql(`
  query GetUnitAndReferences($propertyId: UUID!, $unitId: String!) {
    unit(propertyId: $propertyId, unitId: $unitId) {
      id
      name
      description
      propertyId
      externalReferences {
        id
        direct
        source{
          sourceEntityId
          sourceEntityType
          sourceType
        }
        relationshipSource{
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
      floors {
        id
        name
        index
      }
      people {
        id
        name
        email
        userId
        user {
          _id
          name
          profile {
            email
          }
          lastSeen
          _created
        }
      }
      tenants {
        id
        name
        type
        logo
        image
      }
    }
  }
`);
